// extracted by mini-css-extract-plugin
module.exports = {"consumer_risk_score_container":"uI88lwD","consumer_risk_score_description":"_9O-jnj","notes":"_3_jByDX","scoreGradeTable":"_3bPD7wp"};